<!-- 弹框组件 -->
<template>
  <Popup
    v-model="isShow"
    :overlay-style="{ backgroundColor: 'rgba(0,0,0,0.2)' }"
    round
    :close-on-click-overlay="false"
  >
    <div class="modal">
      <img class="img" src="@/assets/images/error-icon.png" />
      <div class="tips-text" v-html="infoText"></div>
      <button class="confirm-btn" @click="confirm">ok</button>
    </div>
  </Popup>
</template>

<script>
import { Popup } from 'vant';
export default {
  name: 'PopupCard',
  components: {
    Popup,
  },
  props: {
    infoText: {
      type: String,
      default: () => {
        return '哦~你放弃了治疗，<br />想要继续参与可以联系工作人员重新开始！'
      }
    },
    type: {
      type: String,
      default: () => {
        return 'ERROR' // ERROR 错误 LOADING 加载
      }
    }
  },
  data() {
    return {
      isShow: false,
      iconList: {
        ERROR:  require('@/assets/images/error-icon.png'),
        LOADING: require('@/assets/images/loading-icon.png'),
      }
    };
  },
  created() {},
  mounted() {},
  methods: {
    confirm() {
      this.isShow = false
    }
  },
};
</script>

<style scoped lang="scss">
.modal {
  width: 240px;
  height: 284px;
  position: relative;
  text-align: center;
  border-radius: 16.8px;
  background: #ffffff;
  box-shadow: 0px 6.6px 13.8px #000000;
  padding-top: 150px;
  box-sizing: border-box;
  .img {
    width: 150px;
    height: 120px;
    position: absolute;
    top: 30px;
    left: 36px;
  }
  .tips-text {
    width: 204px;
    font-size: 14.4px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 20px;
    color: rgba(74, 74, 74, 1);
    text-align: center;
    vertical-align: top;
    margin: 0 auto;
  }
  .confirm-btn {
    width: 174px;
    height: 33px;
    border-radius: 16.5px;
    background: #1b69fd;
    box-shadow: 0px 3.6px 7.2px #1b69fd;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10.8px;
    font-weight: 700;
    letter-spacing: 0px;
    color: rgba(255, 255, 255, 1);
    border: none;
    position: absolute;
    left: 33px;
    bottom: 33px;
  }
}
</style>
